import React from "react";
import "./styles/print.css";
import logo from "./logo.svg";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import JobsList from "./components/jobs/JobsList";
import HomePage from "./components/HomePage";
import Navbar from "./components/nav/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import Walkin from "./components/Walkin";
import JobDetails from "./pages/JobDetails";

import BlogEditor from "./components/blog/BlogEditor";
import BlogEdit from "./components/blog/BlogEdit";
import Login from "./components/login/Login";
import SignUp from "./components/login/SignUp";
import Prepare from "./components/Prepare/Prepare";
import PostDetail from "./components/Prepare/PostDetail";
import ResumeHomePage from "./components/pages/ResumeHomePage";
import Editor from "./components/pages/Editor";
import Footer from "./components/home/Footer";
import AboutUs from "./components/AboutUs";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ResumeAnalyzer from "./components/ResumeAnalyzer";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import ResumeExtractor from "./components/temp/ResumeExtractor";
import Contact from "./components/contact";
import GeminiAIComponent from "./components/ai/GeminiAIComponent";
import ScrollToTop from "./components/ScrollToTop";
import AIMockInterView from "./components/ai/AIMockInterView";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        {" "}
        {/* Use Routes to wrap Route components */}
        <Route path="/" element={<HomePage />} />
        <Route path="/jobs" element={<JobsList />} />
        <Route path="/jobs/:jobId" element={<JobDetails />} />
        <Route path="/walk-in" element={<Walkin />} />
        <Route path="/blog-editor" exact element={<BlogEditor />} />
        <Route path="/blog-editor/:id" element={<BlogEdit />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/prepare" element={<Prepare />} />
        <Route path="/post/:id" element={<PostDetail />} />
        <Route path="/resume" element={<ResumeHomePage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/editor/:templateId" element={<Editor />} />
        <Route path="/jobs-admin" element={<AdminDashboard />} />
        <Route path="/resume-analyzer" element={<ResumeAnalyzer />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/ResumeExtractor" element={<ResumeExtractor />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/ai-interview" element={<AIMockInterView />} />
        {/* Add more routes as needed */}
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
